export interface CampaignFinance {
  id: string;
  name?: string;
  fiscalCode?: boolean;
  offer_id: any;
  excludedJobs?: any;
  excludedAffilaites?: any;
  includedAreas?: any;
  pricing?: any;
  logo?: number;
  timestamp?: any;
  pause?: boolean;
  totLeads?: number;
  privacies?: any;
  minHour?: number[];
  maxHour?: number[];
  dailyMax?: number;
  // dailyMax?: DailyMax;
  dailyTot?: number;
  dayOfTheWeek?: boolean[];
}

// dailyMax:{"type":"weekly", "days": {"0": {"pause": bool, "maxleads": 0, "timestart": 0000, "timeend": 0000}}}
// export interface DailyMax {
//   type: string;
//   days: Days;
// }

// Tipi dei giorni: se le chiavi sono stringhe numeriche (come in JSON), devono essere stringhe.
// export type Days = {
//   [key in '0' | '1' | '2' | '3' | '4' | '5' | '6']: DailyMaxDayConfig;
// };

// export interface DailyMaxDayConfig {
//   pause: boolean;
//   maxleads: number;
//   timestart: number; 
//   timeend: number;  
// }

export abstract class CampaignFinanceData {
  abstract createCampaignFinance(Campaign: CampaignFinance);
  abstract getCampaignsFinance(pagination, filter, order);
  abstract getCampaignFinance(id: string);
  abstract editCampaignFinance(data: CampaignFinance, id: string);
  abstract deleteCampaignFinance(id: string);
}
